// src/index.ts
var VERSION = "0.7.3";
export {
  VERSION
};
